export default __webpack_public_path__ + "static/media/FUJJ.31568d77.png";